import _toConsumableArray from "D:/xampp/htdocs/SNS_Thai/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.atob.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/esnext.typed-array.to-reversed.js";
import "core-js/modules/esnext.typed-array.to-sorted.js";
import "core-js/modules/esnext.typed-array.with.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.filter.js";
var flag = 0;
var img;
var img1;
var img3;
var commentParams = {
  'filter[thread]': '',
  sort: 'createdAt',
  page: 1,
  perPage: 20,
  index: 1,
  replyId: ''
};
var params = {
  isComment: 1,
  id: '',
  content: '',
  replyId: '',
  commentPostId: ''
};
import { detail, comments, follow, unFollow, postComments, thumbs, collect, signUp, threadDelete, shareIntegral, signalComment, getJoinNum as _getJoinNum } from '@/api/mg';
import getPx from '@/utils/getPx';
import QRCode from 'qrcodejs2';
import $ from 'jquery';
import md5 from 'md5';
var jsonp = require('jsonp');
import { format2DateTime } from '@/utils/util';
export default {
  watch: {
    show: function show() {
      this.item.isSelected = this.show;
    }
  },
  data: function data() {
    return {
      show: false,
      confirmTextShow: false,
      confirmPostShow: false,
      placeholder: this.$t('ssthing'),
      commentList: [],
      detailData: {
        content: {
          text: ''
        },
        user: {
          avatar: ''
        }
      },
      isEmpty: true,
      isFocus: false,
      isAndroidFocus: false,
      isIosFocus: false,
      isFollow: true,
      inputValue: '',
      threadId: '',
      userId: '',
      storeUserId: '',
      qrcode: '',
      item: '',
      canvasImgSrc: '',
      shiftArr: [],
      isCommentShow: true,
      shareShow: true,
      shareShow1: true,
      isDisabled: false,
      resizeHeight: 0,
      postCount: 20,
      loading: false,
      isScorll: false,
      finished: false,
      totalPage: 0,
      totalCount: 0,
      isSend: false,
      isInit: true,
      virtualKeyboard: '',
      delPostId: '',
      bgWidth: '',
      bgHeight: '',
      isBack: true,
      joinNum: 0,
      showDetailBack: true,
      isVdo: false,
      shareVdoUrl: '',
      delPostShow: false,
      userInfoShow: false
    };
  },
  created: function created() {
    flag = 0;
    this.showDetailBack = !this.$route.query.showDetailBack;
    this.storeUserId = localStorage.getItem('userId');
    this.title = this.$route.query.from;
    this.threadId = this.$route.query.threadId;
    this.postCount = this.$route.query.postCount;
    console.log(this.$route.query.from);
    var params = {
      threadId: this.threadId
    };
    this.getJoinNum(params);
    this.getDetail(params);
    commentParams['filter[thread]'] = this.threadId;
    commentParams.page = 1;
    this.getComments(commentParams);
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      var timer = setTimeout(function () {
        _this.creatQrCode();
        // this.handleResize()
        // const video = document.querySelector('.video')
        // this.autoFullScrenn(video)
        clearTimeout(timer);
      }, 1000);
      var u = navigator.userAgent; // 判断手机类型
      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        console.log('12345');
        if (window.Android) {
          var devicePixelRatio = window.devicePixelRatio;
          console.log(devicePixelRatio);
          console.log(window.Android.getStatusBarHeight());
          var pxSize = Number(window.Android.getStatusBarHeight() / devicePixelRatio);
          console.log('pxsize', pxSize);
          $('.titleBar').css('padding-top', pxSize);
          $('.article').css('padding-top', pxSize);
        }
      }
    });
  },
  methods: {
    delComments: function delComments() {
      this.confirmTextShow = true;
    },
    onload: function onload() {
      if (commentParams.page < this.totalPage) {
        commentParams.page++;
        this.isScorll = true;
        this.getComments(commentParams);
      } else {
        this.finished = true;
      }
    },
    translate: function translate(detailData) {
      var _this2 = this;
      var appid = '20211116001000645'; // 百度翻译API的appid
      var key = 'RExx85Y9o4DqUHOrcaqV'; // 百度翻译API的key
      var salt = new Date().getTime();
      var query = detailData.content.text;
      var from = 'th';
      var to = 'en';
      var str1 = appid + query + salt + key;
      var sign = md5(str1);
      var url = "http://api.fanyi.baidu.com/api/trans/vip/translate?q=".concat(query, "&appid=").concat(appid, "&salt=").concat(salt, "&from=").concat(from, "&to=").concat(to, "&sign=").concat(sign);
      jsonp(url, null, function (err, data) {
        if (err) {
          _this2.$toast(err.error_msg);
        } else {
          detailData.content.text = data.trans_result[0].dst;
        }
      });
    },
    toDelete: function toDelete(threadId) {
      this.delPostId = threadId;
      this.confirmPostShow = true;
    },
    toMe: function toMe(pid) {
      this.$router.push({
        path: '/others',
        query: {
          pid: pid,
          from: 'detail'
        }
      });
    },
    toSign: function toSign(type) {
      var _this3 = this;
      if (this.isDisabled) {
        return;
      }
      signUp({
        threadId: this.threadId,
        type: type,
        token: JSON.parse(localStorage.getItem('appParams')).token
      }).then(function (res) {
        if (res.Code === 0) {
          // 0:取消 1:加入
          if (type == 0) {
            _this3.$toast(_this3.$t('cancelJoin'));
          } else {
            _this3.$toast(_this3.$t('signJoin'));
          }
          var timer = setTimeout(function () {
            var params = {
              threadId: _this3.threadId
            };
            _this3.getDetail(params);
            _this3.getJoinNum(params);
            clearTimeout(timer);
          }, 100);
        } else {
          _this3.$toast(_this3.$t('NoData'));
          var _timer = setTimeout(function () {
            _this3.$router.back();
            clearTimeout(_timer);
          }, 1000);
        }
      });
    },
    toTopic: function toTopic(topicId) {
      this.$router.push({
        path: '/social/topic',
        query: {
          topicId: topicId,
          from: 'club'
        }
      });
    },
    toCollect: function toCollect(isFavorite, threadId) {
      var _this4 = this;
      var params = {
        id: threadId,
        isFavorite: !isFavorite
      };
      collect(params).then(function (res) {
        if (res.Code === 0) {
          var _params = {
            threadId: _this4.threadId
          };
          _this4.getDetail(_params);
        } else {
          _this4.$toast(res.Message);
        }
      });
    },
    imgLoad: function imgLoad() {
      var _this5 = this;
      // MG图片
      img1 = new Image();
      img1.src = require('../../assets/images/MG_2.png');
      img1.onload = function () {
        flag++;
        console.log('MG图片加载完成', img1, flag);
      };
      // 头像
      img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        flag++;
        _this5.shareShow = false;
        console.log('头像加载完成', img, flag, _this5.shareShow);
      };
      if (this.detailData.user.avatar) {
        if (this.detailData.user.avatar.match(/^data:(.*);base64,/)) {
          img.src = window.URL.createObjectURL(this.base64ToBlob(this.detailData.user.avatar));
        } else {
          img.src = this.detailData.user.avatar + '?time=' + new Date().valueOf();
        }
      }
      // 背景图片
      img3 = new Image();
      // img3.src = require('https://tpage.soimt.com/APP/SNS/P8.png')
      img3.crossOrigin = 'anonymous';
      img3.onload = function () {
        flag++;
        _this5.shareShow1 = false;
        var maxWidth = 660;
        var maxHeight = 634;
        if (img3.width > Number(maxWidth) && img3.height > Number(maxHeight)) {
          var rate = Math.min(Number(maxWidth) / img3.width, Number(maxHeight) / img3.height);
          _this5.bgWidth = img3.width * rate;
          _this5.bgHeight = img3.height * rate;
        } else if (img3.width > Number(maxWidth)) {
          _this5.bgWidth = Number(maxWidth);
          _this5.bgHeight = Number(maxWidth) / img3.width * img3.height;
        } else if (img.height > Number(maxHeight)) {
          _this5.bgWidth = Number(maxHeight);
          vbgHeight = Number(maxHeight) / img3.height * img3.width;
        } else {
          _this5.bgWidth = img3.width;
          _this5.bgHeight = img3.height;
        }
        console.log('背景图片加载完成', img3, flag, _this5.shareShow1);
      };
      if (this.detailData['content']['indexes']['101']['body'].length) {
        if (this.detailData['content']['indexes']['101']['body'][0].type == 1 || this.detailData['content']['indexes']['101']['body'][0].type == 0) {
          img3.src = this.detailData['content']['indexes']['101']['body'][0].thumbUrl + '?time=' + new Date().valueOf();
        } else if (this.detailData['content']['indexes']['101']['body'][0].type == 2) {
          if (this.isIos()) {
            console.log('ios vdo share ...');
            img3.src = require('../../assets/images/defaultPage.png');
            this.isVdo = false;
          } else {
            console.log('android vdo share ...');
            this.isVdo = true;
            this.shareVdoUrl = this.detailData['content']['indexes']['101']['body'][0].thumbUrl + '?time=' + new Date().valueOf();
          }
        }
      } else {
        this.shareShow1 = false;
        img3.src = require('../../assets/images/defaultPage.png');
      }
    },
    findVdoCover: function findVdoCover(url) {
      var video = document.createElement('video');
      video.setAttribute('crossOrigin', 'anonymous');
      video.setAttribute('src', url);
      video.currentTime = 1;
      video.addEventListener('loadeddata', function (e) {
        console.log(e);
        var canvas = document.getElementById('canvas');
        var ctx = canvas.getContext('2d');
        console.log(video.videoWidth);
        console.log(video.videoHeight);
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        var src = canvas.toDataURL('image/png');
        // return src
        console.log(src);
        // 设置属性
        // video.setAttribute('poster', src);
      });

      // console.log('开始截取视频第一帧...')
      // const video = document.createElement("video")
      // var canvas = document.getElementById('canvas')
      // const ctx = canvas.getContext('2d');
      // video.setAttribute('crossOrigin', 'anonymous')
      // video.setAttribute('src', url)
      // //video.src = url
      // //video.crossOrigin = 'anonymous'
      // var videos = document.querySelector('video');
      // console.log(video)
      // console.log(video.width)
      // console.log(video.height)
      //
      // // video.setAttribute('width', 800)
      // // video.setAttribute('height', 1900)
      // video.currentTime = 1
      //
      // video.oncanplay = () => {
      //   canvas.width = video.width * 3;
      //   canvas.height = video.height * 3;
      //   console.log('canvas.width:' + video.width)
      //   console.log('canvas.height:' + video.height)
      //   ctx.drawImage(video, 0, 0, 1920, 1920)
      //   this.imgsrc = canvas.toDataURL("image/png")
      //   // console.log(this.imgsrc)
      // }
    },
    base64ToBlob: function base64ToBlob(base64Data) {
      var arr = base64Data.split(',');
      var fileType = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var l = bstr.length;
      var u8Arr = new Uint8Array(l);
      while (l--) {
        u8Arr[l] = bstr.charCodeAt(l);
      }
      return new Blob([u8Arr], {
        type: fileType
      });
    },
    fullscreen: function fullscreen(elem) {
      var prefix = 'webkit';
      if (elem[prefix + 'EnterFullScreen']) {
        return prefix + 'EnterFullScreen';
      } else if (elem[prefix + 'RequestFullScreen']) {
        return prefix + 'RequestFullScreen';
      }
      return false;
    },
    autoFullScrenn: function autoFullScrenn(v) {
      var ua = navigator.userAgent.toLowerCase();
      var Android = String(ua.match(/android/i)) === 'android';
      if (!Android) return; // 非android系统不使用;
      var video = v;
      var doc = document;
      var fullscreenvideo = this.fullscreen(doc.createElement('video'));
      if (!this.fullscreen) {
        this.$toast('不支持全屏模式');
        return;
      }
      video.addEventListener('webkitfullscreenchange', function (e) {
        if (!doc.webkitIsFullScreen) {
          // 退出全屏暂停视频
          this.pause();
          // this.pause();
        }
      }, false);
      video.addEventListener('click', function () {
        this.play();
        video[fullscreenvideo]();
      }, false);
      video.addEventListener('ended', function () {
        doc.webkitCancelFullScreen(); // 播放完毕自动退出全屏
      }, false);
    },
    creatQrCode: function creatQrCode() {
      var _this6 = this;
      new QRCode(this.$refs.qrCodeUrl, {
        text: location.href.replace('detail', 'share'),
        width: 200,
        height: 200,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      });
      this.$nextTick(function () {
        _this6.qrcode = document.querySelector('.qrcode canvas');
        console.log(_this6.qrcode, 'this.qrcode');
      });
    },
    toComment: function toComment(pid) {
      if (!this.showDetailBack) {
        this.$router.push({
          path: '/social/comment',
          query: {
            pid: pid,
            threadId: this.threadId,
            showCommentBack: false
          }
        });
      } else {
        this.$router.push({
          path: '/social/comment',
          query: {
            pid: pid,
            threadId: this.threadId
          }
        });
      }
    },
    del: function del() {
      this.confirmTextShow = true;
      this.show = false;
    },
    cancel: function cancel() {
      this.item.isSelected = false;
      this.show = false;
    },
    cancelTextHandler: function cancelTextHandler() {
      this.confirmTextShow = false;
      this.item.isSelected = false;
    },
    confirmOKHandler: function confirmOKHandler() {
      var params = {
        pid: this.pid,
        data: {
          attributes: {
            isDeleted: true
          }
        }
      };
      this.thumpsApi(params, 'delete');
    },
    cancelPostHandler: function cancelPostHandler() {
      this.confirmPostShow = false;
    },
    confirmPostHandler: function confirmPostHandler() {
      var _this7 = this;
      threadDelete({
        threadId: this.delPostId
      }).then(function (res) {
        if (res.Code === 0) {
          _this7.$router.back();
          _this7.confirmPostShow = false;
        } else {
          _this7.$toast(res.Message);
        }
      });
    },
    start: function start(userId, pid, item) {
      this.blur();
      this.userId = userId;
      this.pid = pid;
      this.item = item;
    },
    longpress: function longpress() {
      console.log('进入langPress', localStorage.getItem('userId'), this.userId, this.item);
      if (localStorage.getItem('userId') === this.userId + '') {
        this.item.isSelected = true;
        this.show = true;
      }
    },
    thumbsUp: function thumbsUp(pid, isLike, threadId) {
      if (threadId) {
        var _params2 = {
          data: {
            attributes: {
              isLiked: !isLike
            }
          },
          pid: pid,
          id: threadId
        };
        this.thumpsApi(_params2, 'thread');
      } else {
        var _params3 = {
          data: {
            attributes: {
              isLiked: !isLike
            }
          },
          pid: pid
        };
        this.thumpsApi(_params3, 'comment');
      }
    },
    thumpsApi: function thumpsApi(params, type) {
      var _this8 = this;
      params.token = JSON.parse(localStorage.getItem('appParams')).token;
      thumbs(params).then(function (res) {
        if (res.Code === 0) {
          if (type === 'delete') {
            _this8.item.isSelected = false;
            _this8.confirmTextShow = false;

            // 剔除评论
            _this8.commentList.forEach(function (itm, index) {
              if (itm.id == params.pid) {
                _this8.commentList.splice(index, 1);
              }
            });
            // this.getComments(commentParams)
          }

          if (type === 'comment') {
            // 点赞
            _this8.commentList.forEach(function (itm, index) {
              if (itm.id == params.pid) {
                // 喜欢
                if (params.data.attributes.isLiked) {
                  itm.likeCount = Number(itm.likeCount) + 1;
                  itm.isLiked = true;
                } else {
                  itm.likeCount = Number(itm.likeCount) > 0 ? Number(itm.likeCount) - 1 : 0;
                  itm.isLiked = false;
                }
              }
            });
            // this.getComments(commentParams)
          }

          if (type === 'thread') {
            var _params4 = {
              threadId: _this8.threadId
            };
            _this8.getDetail(_params4);
          }
        } else {
          _this8.$toast(res.Message);
        }
      });
    },
    toReply: function toReply(name, replyId, commentPostId) {
      this.$refs.inputs.focus();
      params.replyId = replyId;
      if (commentPostId) {
        params.commentPostId = commentPostId;
      } else {
        params.commentPostId = '';
      }
      console.log(params, 'params');
      this.placeholder = this.$t('rely') + ' ' + name + ':';
    },
    post: function post(params) {
      var _this9 = this;
      params.token = JSON.parse(localStorage.getItem('appParams')).token;
      postComments(params).then(function (res) {
        if (res.Code === 0) {
          _this9.item = '';
          _this9.placeholder = _this9.$t('ssthing');
          if (params.replyId && params.replyId != '') {
            // 根据replyid查询所有回复内容
            var relyParams = {
              pid: params.replyId
            };
            signalComment(relyParams).then(function (res) {
              if (res.Code === 0) {
                _this9.commentList.forEach(function (itm, index) {
                  console.log('=============== ' + relyParams.pid);
                  if (relyParams.pid == itm.id) {
                    itm.lastThreeComments = [];
                    var len = res.Data.commentPosts.length;
                    if (res.Data.commentPosts[len - 1]) {
                      itm.lastThreeComments.push(res.Data.commentPosts[len - 1]);
                    }
                    if (res.Data.commentPosts[len - 2]) {
                      itm.lastThreeComments.push(res.Data.commentPosts[len - 2]);
                    }
                    if (res.Data.commentPosts[len - 3]) {
                      itm.lastThreeComments.push(res.Data.commentPosts[len - 3]);
                    }
                  }
                });
              }
            });
          } else {
            res.Data.lastThreeComments = [];
            _this9.commentList.unshift(res.Data);
          }
        } else {
          // this.$toast(res.Message)
          var _params5 = {
            threadId: _this9.threadId
          };
          _this9.getDetail(_params5);
        }
        params.replyId = '';
      });
    },
    getComments: function getComments(params) {
      var _this10 = this;
      params.token = JSON.parse(localStorage.getItem('appParams')).token;
      // if (params.token == '') {
      //   // 未登录访问
      //   params.type = 'share'
      // }
      comments(params).then(function (res) {
        if (res.Code === 0) {
          // if (this.isSend) {
          //   this.commentList = []
          //   this.commentList = [...this.commentList, ...res.Data.pageData]
          //   this.isSend = false
          // } else
          if (_this10.isScorll || _this10.isInit || _this10.finished) {
            console.log('初始化或者上滑更新, isScorll: ' + _this10.isScorll + ' isInit: ' + _this10.isInit + ' finished: ' + _this10.finished);
            if (_this10.finished) {
              _this10.commentList.push(res.Data.pageData[res.Data.pageData.length - 1]);
            } else {
              _this10.commentList = [].concat(_toConsumableArray(_this10.commentList), _toConsumableArray(res.Data.pageData));
            }
            _this10.loading = false;
            _this10.isScorll = false;
            _this10.isInit = false;
          }
          _this10.totalPage = res.Data.totalPage;
          _this10.totalCount = res.Data.totalCount;
        } else {
          // this.$toast(res.Message)
        }
      });
    },
    getJoinNum: function getJoinNum(params) {
      var _this11 = this;
      _getJoinNum(params).then(function (res) {
        if (res.Code === 0) {
          console.log('获取活动参与人数:' + JSON.stringify(res));
          _this11.joinNum = res.Data.activity_nums;
          console.log('获取活动参与人数:' + _this11.joinNum);
        }
      });
    },
    getDetail: function getDetail(params) {
      var _this12 = this;
      detail(params).then(function (res) {
        if (res.Code === 0) {
          if (res.Data.end_at) {
            res.Data.end_time2 = res.Data.end_at.replace(/-/g, '/');
          }
          if (res.Data.start_at) {
            res.Data.start_time2 = res.Data.start_at.replace(/-/g, '/');
          }
          _this12.detailData = JSON.parse(JSON.stringify(res.Data));
          _this12.detailData.start_at = format2DateTime(_this12.detailData.start_at);
          _this12.detailData.end_at = format2DateTime(_this12.detailData.end_at);
          if (new Date() < Date.parse(res.Data.start_time2)) {
            _this12.isDisabled = true;
          }
          if (_this12.detailData['content']['indexes'] == '[object Object]' && _this12.detailData['content']['indexes']['101']['body'].length > 0) {
            var data = JSON.parse(JSON.stringify(_this12.detailData['content']['indexes']['101']['body']));
            if ((data[0].type === 1 || data[0].type === 0) && _this12.$route.query.from == 'activity') {
              data.shift();
            }
            _this12.shiftArr = data;
            if (_this12.shiftArr.length > 0 && _this12.shiftArr[0].type == 2) {
              _this12.shiftArr[0].poster = './defaultPage.png';
            }
            // 添加视频封面
            if (_this12.detailData['content']['indexes']['101']['body'][0].type == 2) {
              _this12.detailData['content']['indexes']['101']['body'][0].poster = './defaultPage.png';
            }
          }
          _this12.imgLoad();
          _this12.delPostShow = true;
          _this12.userInfoShow = true;
          console.log(_this12.detailData, 'this.detailData');
          console.log(_this12.detailData.likeReward.favoriteCount, 999999999999);
        } else {
          _this12.$toast(_this12.$t('NoData'));
          var timer = setTimeout(function () {
            _this12.$router.back();
            clearTimeout(timer);
          }, 1000);
        }
      });
    },
    send: function send() {
      if (this.inputValue.trim()) {
        if (params.replyId) {
          params.content = this.inputValue;
          params.id = this.threadId;
          this.post(params);
        } else {
          var params1 = {
            id: this.threadId,
            content: this.inputValue.trim()
          };
          this.post(params1);
        }
        this.isFocus = false;
        this.inputValue = '';
        this.isEmpty = true;
      }
    },
    input: function input(val) {
      if (val.trim()) {
        this.isEmpty = false;
      } else {
        this.isEmpty = true;
      }
    },
    isIos: function isIos() {
      var m = navigator.userAgent;
      var isIos = !!m.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var result = !!isIos;
      return result;
    },
    handleResize: function handleResize() {
      this.$toast('键盘弹起');
      var resizeHeight = document.documentElement.clientHeight || document.body.clientHeight;
      if (resizeHeight < this.originHeight) {
        // 当软键盘弹起，在此处操作
        if (!this.isIos()) {
          this.isFocus = true;
          this.$toast('键盘弹起');
        }
      } else {
        // 当软键盘收起，在此处操作
        if (!this.isIos()) {
          this.isFocus = false;
          this.$toast('键盘收起');
        }
      }
    },
    blur: function blur() {
      if (!this.inputValue) {
        this.isFocus = false;
        this.$refs.inputs.blur();
        this.item = '';
        params.replyId = '';
        this.placeholder = this.$t('ssthing');
      }
      // this.isFocus = false
      // this.inputValue = ''
      // this.isEmpty = true
    },
    focus: function focus() {
      this.isFocus = true;
      this.$refs.inputs.focus();
    },
    share: function share() {
      var token = JSON.parse(localStorage.getItem('appParams')).token;
      // 判断未登录
      if (token == '') {
        var u = navigator.userAgent;
        if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
          window.Android.unLogin();
        } else if (u.indexOf('iPhone') > -1 || u.indexOf('iPad') > -1) {
          this.$bridge.callhandler('unLogin', null, function (response) {});
        }
        return;
      }

      // this.$toast('开发中...')
      // return
      console.log(this.shareShow, this.shareShow1, 'flag');
      // 视频分享
      if (this.isVdo && !this.shareShow && this.qrcode) {
        this.drawVdo();
      } else if (!this.shareShow && !this.shareShow1 && this.qrcode) {
        this.draw();
      } else {
        this.$toast(this.$t('limitShare'));
      }
    },
    getShareModule: function getShareModule(imgSrc) {
      shareIntegral({
        threadId: this.threadId,
        token: JSON.parse(localStorage.getItem('appParams')).token
      }).then(function () {});
      var u = navigator.userAgent; // 判断手机类型
      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        window.Android.share(imgSrc);
      } else if (u.indexOf('iPhone') > -1 || u.indexOf('iPad') > -1) {
        this.$bridge.callhandler('share', {
          'content': imgSrc
        }, function (response) {});
      }
    },
    filter: function filter(html) {
      return html.replace(/<(?:.|\n)*?>/gm, '').replace(/(&rdquo;)/g, '"').replace(/&ldquo;/g, '"').replace(/&mdash;/g, '-').replace(/&nbsp;/g, '').replace(/&gt;/g, '>').replace(/&lt;/g, '<').replace(/<[\w\s"':=\/]*/, '');
    },
    drawVdo: function drawVdo() {
      var that = this;
      var video = document.createElement('video');
      video.setAttribute('crossOrigin', 'anonymous');
      video.setAttribute('src', this.shareVdoUrl);
      video.currentTime = 1;
      var qrCode = this.qrcode;
      video.addEventListener('loadeddata', function (e) {
        console.log(e);
        var text = that.filter(that.detailData.content.text).substr(0, 20) + '......';
        var canvas = document.getElementById('canvas');
        var ctx = canvas.getContext('2d');
        console.log(video.videoWidth);
        console.log(video.videoHeight);
        var maxWidth = 660;
        var maxHeight = 634;
        var cWidth = 0;
        var cHeight = 0;
        if (video.videoWidth > Number(maxWidth) && video.videoHeight > Number(maxHeight)) {
          var rate = Math.min(Number(maxWidth) / img3.width, Number(maxHeight) / video.videoHeight);
          cWidth = video.videoWidth * rate;
          cHeight = video.videoHeight * rate;
        } else if (video.videoWidth > Number(maxWidth)) {
          cWidth = Number(maxWidth);
          cHeight = Number(maxWidth) / video.videoWidth * video.videoHeight;
        } else if (video.videoHeight > Number(maxHeight)) {
          cWidth = Number(maxHeight);
          cHeight = Number(maxHeight) / video.videoHeight * video.videoWidth;
        } else {
          cWidth = video.videoWidth;
          cHeight = video.videoHeight;
        }
        if (cWidth < 300) cWidth = 350;
        console.log('cWidth: ' + cWidth);
        console.log('cHeight: ' + cHeight);
        canvas.width = cWidth * 3;
        canvas.height = (cHeight + 230) * 3;
        ctx.fillStyle = '#FFFFFF';
        ctx.fillRect(0, 0, getPx(cWidth * 6), getPx((cHeight + 300) * 6));
        /* 背景图*/
        ctx.drawImage(video, 0, 0, cWidth * 3, cHeight * 3);
        /* 用户头像*/
        ctx.drawImage(img, getPx(25 * 3), getPx((cHeight + 80) * 4), getPx(70 * 3), getPx(70 * 3));
        ctx.font = "".concat(getPx(28 * 3), "px medium");
        ctx.fillStyle = 'rgba(0, 0, 0, 1)';
        /* 用户昵称*/
        ctx.fillText(that.detailData.user.nickname, getPx(112 * 3), getPx((cHeight + 120) * 4), getPx(522 * 3));
        /* MG图标*/
        ctx.drawImage(img1, getPx((cWidth + 80) * 4), getPx((cHeight + 200) * 5), getPx(50 * 3), getPx(50 * 3));
        /* 二维码*/
        ctx.drawImage(that.qrcode, getPx(25 * 3), getPx((cHeight + 150) * 5), getPx(150 * 3), getPx(150 * 3));
        ctx.font = "".concat(getPx(22 * 3), "px medium");
        ctx.fillStyle = 'rgba(0, 0, 0, 0.5)';
        /* 二维码文字*/
        ctx.fillText('Scan QR Code', getPx(195 * 3), getPx((cHeight + 210) * 5), getPx(522 * 3));
        ctx.font = "".concat(getPx(22 * 3), "px medium");
        ctx.fillStyle = 'rgba(0, 0, 0, 0.5)';
        ctx.fillText(that.$t('checkTheDetails'), getPx(195 * 3), getPx((cHeight + 230) * 5), getPx(522 * 3));
        /* 内容*/
        ctx.fillText(text, getPx(25 * 3), getPx((cHeight + 100) * 5), getPx(cWidth * 3));
        var src = canvas.toDataURL('image/png');
        // console.log(src)
        that.getShareModule(src);
        // 设置属性
        // video.setAttribute('poster', src);
      });
    },
    draw: function draw() {
      var text = this.filter(this.detailData.content.text).substr(0, 20) + '......';
      var c = document.getElementById('canvas');
      if (this.bgWidth < 300) {
        this.bgWidth = 500;
      }
      c.setAttribute('width', getPx(this.bgWidth * 3) + 'px');
      c.setAttribute('height', getPx((this.bgHeight + 300) * 3) + 'px');
      // c.setAttribute('style', 'display:block;')
      // const timer = setTimeout(() => {
      //   c.setAttribute('style', 'display:none;')
      //   clearTimeout(timer)
      // }, 30000)
      var ctx = c.getContext('2d');
      // ctx.fillStyle = '#2c2e31'
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, getPx(this.bgWidth * 3), getPx((this.bgHeight + 300) * 3));
      ctx.drawImage(img3, getPx(0), getPx(0), getPx(this.bgWidth * 3), getPx(this.bgHeight * 3));
      /* 用户头像*/
      ctx.drawImage(img, getPx(25 * 3), getPx(this.bgHeight * 3 - 300), getPx(70 * 3), getPx(70 * 3));
      /* MG图标*/
      ctx.drawImage(img1, getPx(this.bgWidth * 3 - 200), getPx((this.bgHeight + 200) * 3), getPx(50 * 3), getPx(50 * 3));
      /* 二维码*/
      ctx.drawImage(this.qrcode, getPx(25 * 3), getPx((this.bgHeight + 100) * 3), getPx(150 * 3), getPx(150 * 3));
      ctx.font = "".concat(getPx(28 * 3), "px medium");
      ctx.fillStyle = 'rgba(0, 0, 0, 1)';
      /* 用户昵称*/
      ctx.fillText(this.detailData.user.nickname, getPx(112 * 3), getPx(this.bgHeight * 3 - 160), getPx(522 * 3));
      ctx.font = "".concat(getPx(22 * 3), "px medium");
      ctx.fillStyle = 'rgba(0, 0, 0, 0.5)';
      /* 二维码文字*/
      ctx.fillText('Scan QR Code', getPx(195 * 3), getPx((this.bgHeight + 200) * 3), getPx(522 * 3));
      ctx.font = "".concat(getPx(22 * 3), "px medium");
      ctx.fillStyle = 'rgba(0, 0, 0, 0.5)';
      ctx.fillText(this.$t('checkTheDetails'), getPx(195 * 3), getPx((this.bgHeight + 230) * 3), getPx(522 * 3));
      /* 内容*/
      ctx.fillText(text, getPx(25 * 3), getPx((this.bgHeight + 50) * 3), getPx(this.bgWidth * 3));
      // // 绘制多行文字
      // this.canvasTextAutoLine(this.detailData.content.text, c, 375 * 0.1, 640 * 0.5, 20)
      this.canvasImgSrc = c.toDataURL('image/png');
      // console.log(this.canvasImgSrc)
      this.getShareModule(this.canvasImgSrc);
    },
    canvasTextAutoLine: function canvasTextAutoLine(str, canvas, initX, initY, lineHeight) {
      var ctx = canvas.getContext('2d');
      var lineWidth = 0;
      var canvasWidth = document.documentElement.clientWidth;
      var lastSubStrIndex = 0;
      for (var i = 0; i < str.length; i++) {
        lineWidth += ctx.measureText(str[i]).width;
        if (lineWidth > canvasWidth * 0.8) {
          // 减去initX,防止边界出现的问题
          ctx.fillText(str.substring(lastSubStrIndex, i), initX, initY);
          initY += lineHeight;
          lineWidth = 0;
          lastSubStrIndex = i;
        }
        if (i === str.length - 1) {
          ctx.fillText(str.substring(lastSubStrIndex, i + 1), initX, initY);
        }
      }
    },
    toFollow: function toFollow(userId) {
      var _this13 = this;
      var params = {
        toUserId: userId
      };
      follow(params).then(function (res) {
        if (res.Code === 0) {
          var params1 = {
            threadId: _this13.threadId
          };
          _this13.getDetail(params1);
        } else {
          _this13.$toast(res.Message);
        }
      });
    },
    toUnfollow: function toUnfollow(userId) {
      var _this14 = this;
      var params = {
        type: 1,
        id: userId
      };
      console.log(unFollow, 'params');
      unFollow(params).then(function (res) {
        if (res.Code === 0) {
          var params1 = {
            threadId: _this14.threadId
          };
          _this14.getDetail(params1);
        } else {
          _this14.$toast(res.Message);
        }
      });
    },
    back: function back() {
      var _this15 = this;
      var timer = setTimeout(function () {
        if (_this15.$route.query.back == 'index') {
          _this15.$router.push({
            path: "/social/club"
          });
        } else {
          _this15.$router.back();
        }
        clearTimeout(timer);
      }, 100);
    },
    getKeyCode: function getKeyCode(e) {
      // this.$toast(e.keyCode)
      if (e.keyCode === 13) {
        // this.$toast('发送')
      }
    }
  }
};